export type StatusTone = "success" | "warning" | "error" | "info" | "neutral" | "violet";

const DOT_TONES: Record<StatusTone, string> = {
  success: "bg-emerald-500",
  warning: "bg-amber-400",
  error: "bg-red-500",
  info: "bg-blue-500",
  neutral: "bg-gray-300",
  violet: "bg-violet-500",
};

const CHIP_TONES: Record<StatusTone, string> = {
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  error: "bg-red-50 text-red-700",
  info: "bg-blue-50 text-blue-700",
  neutral: "bg-gray-100 text-gray-600",
  violet: "bg-violet-50 text-violet-700",
};

export const StatusDot = ({
  tone,
  label,
  className = "",
}: {
  tone: StatusTone;
  label: string;
  className?: string;
}) => (
  <span className={`inline-flex items-center gap-1.5 text-xs font-medium text-gray-600 ${className}`}>
    <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${DOT_TONES[tone]}`} />
    {label}
  </span>
);

export const StatusChip = ({ tone, label }: { tone: StatusTone; label: string }) => (
  <span
    className={`inline-flex h-6 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-semibold ${CHIP_TONES[tone]}`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${DOT_TONES[tone]}`} />
    {label}
  </span>
);
